import { FC } from "react";
import { Modal, Button } from "react-bootstrap";

interface ConfirmationModalProps {
  show: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title?: string;
  message?: any;
  confirmLabel?: string;
  cancelLabel?: string;
  isLoading?:boolean;
  className?: string;
}

const XConfirm: FC<ConfirmationModalProps> = ({
  show,
  onCancel,
  onConfirm,
  title = "Confirmation",
  message = "Are you sure?",
  confirmLabel = "Yes",
  cancelLabel = "Close",
  isLoading = false,
  className = ""
}) => {
  return (
    <Modal show={show} onHide={onCancel} centered className={className}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="content">
          {typeof message === "string" ? <p>{message}</p> : message}
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button
          variant="primary"
          className="btn-theme btn-border"
          onClick={onCancel}
          disabled={isLoading}
        >
          {isLoading ? "Loading..." : cancelLabel}
        </Button>
        <Button
          variant="primary"
          type="button"
          className="btn-theme"
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? "Loading..." : confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default XConfirm;
